import { Injectable } from '@angular/core';
import { TextInputTypeBuilder } from '../text/text-input-type.builder';
import { InputType } from '@capturum/builders/core';

@Injectable({ providedIn: 'root' })
export class NumberInputTypeBuilder extends TextInputTypeBuilder {
  protected inputType: string = InputType.number;
}
